import { ORDER_DINE_IN_TYPE } from './order';
import { TOrder } from 'src/types/orders';

export enum DELIVERY_METHOD {
  SMS = 'sms',
  APP_NOTIFICATION = 'app_notification',
}

export enum DELIVERY_TYPE {
  PICKUP = 'p',
  DELIVERY = 'd',
  DINE_IN = 'i',
}

export enum BRANCH_DELIVERY_TYPE {
  BOTH = 'b',
  PICKUP = 'p',
  DELIVERY = 'd',
}

export const DELIVERY_TYPES: {
  PICKUP: BRANCH_DELIVERY_TYPE.PICKUP;
  DELIVERY: BRANCH_DELIVERY_TYPE.DELIVERY;
  BOTH: BRANCH_DELIVERY_TYPE.BOTH;
} = {
  PICKUP: BRANCH_DELIVERY_TYPE.PICKUP,
  DELIVERY: BRANCH_DELIVERY_TYPE.DELIVERY,
  BOTH: BRANCH_DELIVERY_TYPE.BOTH,
};

export enum ORDER_DELIVERY_TYPES {
  PICKUP = 'p',
  PICKUP_ADDRESS = 'pa',
  PICKUP_TIME = 'pt',
  PICKUP_INSIDE = 'pi',
  DINE_IN = 'i',
  DINE_IN_ADDRESS = 'ia',
  DINE_IN_TIME = 'it',
  DELIVERY_ADDRESS = 'da',
  DELIVERY_TIME = 'dt',
  DELIVERY = 'd',
}

export enum DELIVERY_TYPE_PICKER_OPTION {
  PICKUP,
  CURBSIDE,
  DELIVERY,
  DINE_IN,
}

export const getOrderDeliveryType = (delivery_type_code: ORDER_DELIVERY_TYPES) => {
  return [
    ORDER_DELIVERY_TYPES.PICKUP,
    ORDER_DELIVERY_TYPES.PICKUP_ADDRESS,
    ORDER_DELIVERY_TYPES.PICKUP_TIME,
    ORDER_DELIVERY_TYPES.PICKUP_INSIDE,
    ORDER_DELIVERY_TYPES.DINE_IN,
    ORDER_DELIVERY_TYPES.DINE_IN_ADDRESS,
    ORDER_DELIVERY_TYPES.DINE_IN_TIME,
  ].includes(delivery_type_code)
    ? DELIVERY_TYPES.PICKUP
    : DELIVERY_TYPES.DELIVERY;
};

export const getOrderDeliveryTypeTitle = (order: TOrder) => {
  if (getOrderDeliveryType(order.delivery_type_code) === DELIVERY_TYPES.DELIVERY) {
    return 'txt_delivery';
  } else if (order.dinein?.dinein_delivery_type === ORDER_DINE_IN_TYPE.DINE_IN) {
    return 'dine_in';
  } else if (order.curbside) {
    return 'curbside';
  } else return 'txt_pickup';
};
